export function KeyFeatures({ firm }: { firm: PropFirm }) {
  const features = firm.features;

  return (
    <div className="bg-white/10 p-6 rounded-xl shadow text-yellow-100">
      <h2 className="text-2xl font-bold mb-4 text-yellow-400">Key Features</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <div>
          <h4 className="text-sm text-yellow-300">Max Funding</h4>
          <p className="font-semibold">{features.maxFunding}</p>
        </div>
        <div>
          <h4 className="text-sm text-yellow-300">Profit Split</h4>
          <p className="font-semibold">{features.profitSplit}</p>
        </div>
        <div>
          <h4 className="text-sm text-yellow-300">Time Limit</h4>
          <p className="font-semibold">{features.timeLimit}</p>
        </div>
        <div>
          <h4 className="text-sm text-yellow-300">Leverage</h4>
          <p className="font-semibold">{features.leverage}</p>
        </div>
        <div>
          <h4 className="text-sm text-yellow-300">Max Drawdown</h4>
          <p className="font-semibold">{features.maxDrawdown}</p>
        </div>
        <div>
          <h4 className="text-sm text-yellow-300">Payout</h4>
          <p className="font-semibold">{features.payout}</p>
        </div>
      </div>
    </div>
  );
}
